import {
  ContentfulPopularSearchesQuery,
  ContentfulPopularSearchesQueryVariables,
  ContentfulTutoringPageQuery,
  ContentfulTutoringPageQueryVariables,
  ContentfulTutoringPageSubjectSubcategoriesQuery,
  ContentfulTutoringPageSubjectSubcategoriesQueryVariables
} from "@outschool/gql-frontend-generated";
import { useLocale } from "@outschool/localization";
import { QueryResult, useQueryWithPreviousData } from "@outschool/ui-apollo";
import React from "react";

import ContentfulSubjectSubcategoriesQuery from "../queries/ContentfulSubjectSubcategoriesQuery";
import ContentfulTutoringPageCollectionQuery from "../queries/ContentfulTutoringPageCollectionQuery";
import ContentfulTutoringPopularSearchesQuery from "../queries/ContentfulTutoringPopularSearchesQuery";
import { subject } from "../utils/tutoringConst";

type TutoringPageQueryResult = {
  loading: boolean;
  error?: QueryResult["error"];
  // @ts-ignore TS(2339): Property 'items' does not exist on type '{ __typen... Remove this comment to see the full error message
  visualLinkGridsCollectionItems?: ContentfulTutoringPageQuery["contentfulTutoringPageCollection"]["items"][number]["visualLinkGridsCollection"]["items"];
  // @ts-ignore TS(2339): Property 'items' does not exist on type '{ __typen... Remove this comment to see the full error message
  articles?: ContentfulTutoringPageQuery["contentfulTutoringPageCollection"]["items"][number]["articlesCollection"]["items"];
  // @ts-ignore TS(2339): Property 'items' does not exist on type '{ __typen... Remove this comment to see the full error message
  popularSubjects?: ContentfulTutoringPageQuery["contentfulTutoringPageCollection"]["items"][number]["popularTutoringSubjectsCollection"]["items"];
};

export default function useTutoringPageQuery(): TutoringPageQueryResult {
  const locale = useLocale();

  const { data, loading, error } = useQueryWithPreviousData<
    ContentfulTutoringPageQuery,
    ContentfulTutoringPageQueryVariables
  >(ContentfulTutoringPageCollectionQuery, {
    variables: {
      locale,
      preview: false
    }
  });

  const tutoringPageCollectionItems =
    data?.contentfulTutoringPageCollection?.items?.[0];

  const visualLinkGridsCollectionItems =
    tutoringPageCollectionItems?.visualLinkGridsCollection?.items;

  const articles = tutoringPageCollectionItems?.articlesCollection?.items;

  const popularSubjects =
    tutoringPageCollectionItems?.popularTutoringSubjectsCollection?.items;

  return {
    error,
    loading,
    visualLinkGridsCollectionItems,
    articles,
    popularSubjects
  };
}

export const useSubjectSubcategories = (subject: subject) => {
  const locale = useLocale();

  const { data, loading } = useQueryWithPreviousData<
    ContentfulTutoringPageSubjectSubcategoriesQuery,
    ContentfulTutoringPageSubjectSubcategoriesQueryVariables
  >(ContentfulSubjectSubcategoriesQuery, {
    variables: {
      locale,
      preview: false,
      subject
    }
  });

  const subcategories = React.useMemo(() => {
    return (
      data?.contentfulTutoringPageCollection?.items?.[0]
        ?.carouselSubcategoriesCollection?.items || []
    );
  }, [data]);

  return { subcategories, loading };
};

export const usePopularSearches = () => {
  const locale = useLocale();

  const { data, loading } = useQueryWithPreviousData<
    ContentfulPopularSearchesQuery,
    ContentfulPopularSearchesQueryVariables
  >(ContentfulTutoringPopularSearchesQuery, {
    variables: {
      locale,
      preview: false
    }
  });

  const topics = React.useMemo(() => {
    return (
      data?.contentfulTutoringPageCollection?.items?.[0]
        ?.popularSearchLinksCollection?.items || []
    );
  }, [data]);

  return { topics, loading };
};
